import(/* webpackMode: "eager" */ "/vercel/path0/src/app/safety/page.tsx");
